import { useCallback, useEffect, useState } from 'react';
import { getUrl } from '../../helpers/api/api';
import { pcoAuthMe_endpoint } from '../../helpers/api/apiConstants';

const SESSION_TOKEN_KEY = 'pco_portal_session_token';

export const getStoredPcoToken = () => localStorage.getItem(SESSION_TOKEN_KEY);
export const storePcoToken = (token) => localStorage.setItem(SESSION_TOKEN_KEY, token);
export const clearStoredPcoToken = () => localStorage.removeItem(SESSION_TOKEN_KEY);

/**
 * Congregant portal's equivalent of the admin portal's useAuthUser, backed
 * by Planning Center login instead of Firebase. The session token lives in
 * localStorage (see pcoCallback.js) rather than a cookie, since the
 * frontend (Netlify) and backend (Heroku) are different domains - it's
 * sent as an Authorization header on each check instead, and the backend
 * verifies its signature/expiry (see authController.getSessionUser).
 */
const usePcoAuthUser = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = getStoredPcoToken();
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(getUrl(pcoAuthMe_endpoint), {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (!response.ok) throw new Error('Session invalid');
            setUser(await response.json());
        } catch (error) {
            clearStoredPcoToken();
            setUser(null);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const logout = () => {
        clearStoredPcoToken();
        setUser(null);
    };

    return { user, loading, logout, refresh };
};

export default usePcoAuthUser;
